import React from 'react';
import { observer, inject } from 'mobx-react';

@inject( 'wcpStore' )
@observer
class FeedbackForm extends React.Component {

    changeHandler = event => {
        const name = event.target.name;
        const value = event.target.value;
        this.props.wcpStore.setFormControl(name, value);
    }

    checkBoxChangeHandler = event => {
        const name = event.target.name;
        const checked = event.target.checked;
        this.props.wcpStore.setFormControl(name, checked ? 1 : 0);
    }

    handleSubmit = event => {
        event.preventDefault();
    }



    render() {
        const { have_syn,
            type_of_syn_colours_for_letters,
            type_of_syn_colours_for_numbers,
            type_of_syn_colours_for_words,
            type_of_syn_colours_for_other_sequences,
            type_of_syn_personalities_for_letters,
            type_of_syn_personalities_for_numbers,
            type_of_syn_spatial_arrangement_for_letters,
            type_of_syn_spatial_arrangement_for_numbers,
            type_of_syn_spatial_arrangement_for_other_sequences,
            type_of_syn_other,
            type_of_syn_comments,
            colours_for_words,
            colours_for_words_comments,
            syn_ex,
            proj_assoc_comments,
            positives,
            bugs_comments,
            confused_comments,
            missing_comments,
            next_comments,
            general_comments } = this.props.wcpStore.formControls;

        const showSynQuestions = have_syn == 1 || have_syn == 2;
        return (

            <form onSubmit={this.handleSubmit} style = {{ maxWidth: 900, display: 'inline-block', textAlign:'left', marginBottom: 20 }}>
            <h1>Thank you for taking the time to test this multicolour picker!</h1>
                <p>This multi-colour picker is still in development, so your
                    feedback is invaluable to us to improve it. All of your responses are
                    and will always remain anonymous, although they may be included in
                    possible future publications about the design and development of this
                    tool. They will otherwise remain confidential to our research group, and
                    will primarily be used to refine and improve the multi-colour
                    picker.</p> <h3>Do you have synaesthesia?</h3>
                                    <p>Synaesthesia is typically characterised as a "merging of the
                    senses". This means that when a synaesthete perceives a stimulus in one
                    sense - for example, reading a word - they may also experience other
                    sensory information, like a colour or a taste. These associations are
                    typically consistent throughout life and automatic. If you're curious
                    about synaesthesia, the <a href="http://polychromeproject.co.uk/about-synaesthesia">About
                    Synaesthesia page on our website</a> and the <a href="https://www.syntoolkit.org/faqs">FAQ page on the MULTISENSE
                    Project SynToolkit website</a> are good places to start.</p>

                <p>Please select the answer that best describes you:</p>
                <table id="have-syn">
                    <tbody>
                    <tr >
                        <td >
                            <input id="have-syn-1" name="have_syn" onChange={this.changeHandler} checked={have_syn === "1"} type="radio" value="1"/></td>
                        <td >
                            <label for="have-syn-1">I definitely have synaesthesia, and have taken a test for synaesthesia before.</label>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input id="have-syn-2" name="have_syn" onChange={this.changeHandler} checked={have_syn === "2"} type="radio" value="2"/></td>
                        <td>
                            <label for="have-syn-2">I believe I have synaesthesia, but I've never taken a test.</label>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input id="have-syn-3" name="have_syn" onChange={this.changeHandler} checked={have_syn === "3"} type="radio" value="3"/></td>
                        <td>
                            <label for="have-syn-3">I don't think I have synaesthesia.</label>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input id="have-syn-4" name="have_syn" onChange={this.changeHandler} checked={have_syn === "4"} type="radio" value="4"/></td>
                        <td>
                            <label for="have-syn-4">I'm sure I don't have synaesthesia.</label>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <p>Whether you have synaesthesia or not, we still welcome your
feedback about the multi-colour picker and any ideas about how we can
improve it.</p>
                {showSynQuestions && <div className="conditional-area">
            <h3>What type(s) of synaesthesia do you have?</h3>
            <table id="type_of_syn">
                <tbody>
                <tr>
                    <td><label>Colours for letters</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_colours_for_letters === 1} id="type_of_syn_colours_for_letters" name="type_of_syn_colours_for_letters" type="checkbox" /></td>
                </tr>
                <tr>
                    <td><label>Colours for numbers</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_colours_for_numbers === 1} id="type_of_syn_colours_for_numbers" name="type_of_syn_colours_for_numbers" type="checkbox" /></td>
                </tr>
                <tr>
                    <td><label>Colours for words</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_colours_for_words === 1} id="type_of_syn_colours_for_words" name="type_of_syn_colours_for_words" type="checkbox" /></td>
                </tr>
                <tr>
                    <td><label>Colours for other sequences (e.g. days of the week, months of the year)</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_colours_for_other_sequences === 1} id="type_of_syn_colours_for_other_sequences" name="type_of_syn_colours_for_other_sequences" type="checkbox" /></td>
                </tr>
                <tr>
                    <td><label>Personalities for letters</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_personalities_for_letters === 1} id="type_of_syn_personalities_for_letters" name="type_of_syn_personalities_for_letters" type="checkbox" /></td>
                </tr>
                <tr>
                    <td><label>Personalities for numbers</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_personalities_for_numbers === 1} id="type_of_syn_personalities_for_numbers" name="type_of_syn_personalities_for_numbers" type="checkbox" /></td>
                </tr>
                <tr>
                    <td><label>Spatial arrangement for letters</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_spatial_arrangement_for_letters === 1} id="type_of_syn_spatial_arrangement_for_letters" name="type_of_syn_spatial_arrangement_for_letters" type="checkbox" /></td>
                </tr>
                <tr>
                    <td><label>Spatial arrangement for numbers</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_spatial_arrangement_for_numbers === 1} id="type_of_syn_spatial_arrangement_for_numbers" name="type_of_syn_spatial_arrangement_for_numbers" type="checkbox" /></td>
                </tr>
                <tr>
                    <td><label>Spatial arrangement for other sequences (e.g. days of the week, months of the year)</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_spatial_arrangement_for_other_sequences === 1} id="type_of_syn_spatial_arrangement_for_other_sequences" name="type_of_syn_spatial_arrangement_for_other_sequences" type="checkbox" /></td>
                </tr>
                <tr>
                    <td><label>Other (please elaborate below)</label></td>
                    <td><input onChange={this.checkBoxChangeHandler} checked={type_of_syn_other === 1} id="type_of_syn_other" name="type_of_syn_other" type="checkbox" /></td>
                </tr>
                </tbody>
            </table>
            <p><label>If you clicked "Other" or would like to describe your experience in more detail, please elaborate here:</label>
                <textarea onChange={this.changeHandler} value={type_of_syn_comments} id="type_of_syn_comments" cols="100" name="type_of_syn_comments" rows="5"></textarea></p>

                <h3>How would you characterise the colours you typically experience for whole words?</h3>
                    <p>Please select the statement that best captures your typical experience, and use the text box below to elaborate if you would like to do so.</p>
                <table id="colours_for_words">
                    <tbody>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={colours_for_words === "1"} id="colours_for_words_the_whole_word_has_its_own_colour_unrelated_to_the_colours_of_its_letters" name="colours_for_words" required="" type="radio" value="1" /></td>
                        <td><label>The whole word has its own colour unrelated to the colours of its letters</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={colours_for_words === "2"} id="colours_for_words_the_whole_word_takes_one_colour_from_one_of_its_first_letters" name="colours_for_words" required="" type="radio" value="2" /></td>
                        <td><label>The whole word takes one colour from one of its first letters</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={colours_for_words === "3"} id="colours_for_words_the_whole_word_has_a_unique_colour_combination_based_on_a_few_of_its_letter_colours" name="colours_for_words" required="" type="radio" value="3" /></td>
                        <td><label>The whole word has a unique colour combination based on a few of its letter colours</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={colours_for_words === "4"}  id="colours_for_words_there_is_no_separate_colour_for_the_whole_word_only_a_mix_of_the_colours_of_each_letter" name="colours_for_words" required="" type="radio" value="4" /></td>
                        <td><label>There is no separate colour for the whole word, only a mix of the colours of each letter</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={colours_for_words === "5"}  id="colours_for_words_there_is_no_separate_colour_for_the_whole_word_only_a_mix_of_the_colours_of_each_letter" name="colours_for_words" required="" type="radio" value="5" /></td>
                        <td><label>I do not experience any colours for words</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={colours_for_words === "6"} id="colours_for_words_other" name="colours_for_words" required="" type="radio" value="6" /></td>
                        <td><label>Other (please elaborate below)</label></td>
                    </tr>
                    </tbody>
                </table>
                <p>If you clicked "Other" or would like to describe your experience in more detail, please elaborate here:</p>
                <p><textarea onChange={this.changeHandler} value={colours_for_words_comments} id="colours_for_words_comments" cols="100" name="colours_for_words_comments" rows="5"></textarea></p>
                <p>&nbsp;</p>
                <h3>How do you experience colours for words?</h3>
                    <p>Please select the statement that best captures your typical experience, and use the text box below to elaborate if you would like to do so.</p>
                <table id="syn_ex">
                    <tbody>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={syn_ex === "external"} name="syn_ex" required="" type="radio" value="external" /></td>
                        <td><label>I see the colour overlaid on the words themselves</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={syn_ex === "vision"} name="syn_ex" required="" type="radio" value="vision" /></td>
                        <td><label>I see the colour in my vision, but not on top of the words</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={syn_ex === "internal"} name="syn_ex" required="" type="radio" value="internal" /></td>
                        <td><label>I experience colour in my head (my mind's eye), but not in my vision</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={syn_ex === "knowing"} name="syn_ex" required="" type="radio" value="knowing" /></td>
                        <td><label>I don't experience colours in my vision or experience it in my head, but I have a strong feeling of KNOWING what the colour must be</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={syn_ex === "none"} name="syn_ex" required="" type="radio" value="bobe" /></td>
                        <td><label>I do not experience colours for words</label></td>
                    </tr>
                    <tr>
                        <td><input onChange={this.changeHandler} checked={syn_ex === "other"} name="syn_ex" required="" type="radio" value="other" /></td>
                        <td><label>Other (please elaborate below)</label></td>
                    </tr>
                    </tbody>
                </table>
                <p>If you clicked "Other" or would like to describe your experience in more detail, please elaborate here:</p>
                <p><textarea onChange={this.changeHandler} value={proj_assoc_comments} id="proj_assoc_comments" cols="100" name="proj_assoc_comments" rows="5"></textarea></p>
                </div>}




                <h2>How was the the colour picker?</h2>
                <h3>What worked well?</h3>
                <p>What did you like about the picker, and/or what aspects of it did you think worked particularly well? Do you have any suggestions for improving them?</p>
                <p><textarea onChange={this.changeHandler} value={positives} id="positives" cols="100" rows="5" name="positives"></textarea></p>
                <h3>What confused you?</h3>
                <p>What existing features could be easier to use or more intuitive? Do you have any suggestions for improving them?</p>
                <p><textarea onChange={this.changeHandler} value={bugs_comments} id="bugs_comments" cols="100" rows="5" name="bugs_comments"></textarea></p>
                <h3>What didn't work?</h3>
                <p>Did you encounter any bugs or problems with the picker? Please give us as much detail as possible about what you were trying to do and what happened.</p>
                <p><textarea onChange={this.changeHandler} value={confused_comments} id="confused_comments" cols="100" rows="5" name="confused_comments"></textarea></p>
                <h3>What's missing?</h3>
                <p>What aspects of your synaesthetic colours for words couldn't be captured by the colour picker? Do you have any suggestions for improving&nbsp;this?</p>
                <p><textarea onChange={this.changeHandler} value={missing_comments} id="missing_comments" cols="100" rows="5" name="missing_comments"></textarea></p>
                <h3>What's next?</h3>
                <p>What features of the multi-colour picker would you like to see in future versions? What would you like to be able to do with it, or use it for?</p>
                <p><textarea onChange={this.changeHandler} value={next_comments} id="next_comments" cols="100" rows="5" name="next_comments"></textarea></p>
                <h3>Other Thoughts?</h3>
                <p><label htmlFor="general_comments">Anything else you would like to tell us? Leave any other thoughts, advice, or feedback here.</label>
                    <textarea onChange={this.changeHandler} value={general_comments} id="general_comments" cols="100" rows="5" name="general_comments"></textarea></p>
                <p>&nbsp;</p>
                <h1 style={{marginTop:20}}>Submit This Form</h1>
                <p>Please click "Finish" below to save your responses. You can return to the test to keep using it if you like.
                If you would like to be notified about our progress, you can&nbsp;<a>sign up here to receive email updates</a>.</p>

            </form>
            );
        }
    }

export default FeedbackForm;